import { useUsersByGroups } from '@/hooks'
import {
  SearchAutocomplete,
  SearchAutocompleteOption,
} from '@/components/inputs'
import { UserGroups } from '@/types'

type EmployeesMultiSelectProps = {
  value?: string
  onChange: (value: string) => void
  placeholder: string
  groups?: UserGroups[]
}

const DEFAULT_GROUPS: UserGroups[] = [
  UserGroups.MANAGER,
  UserGroups.EMPLOYEE,
  UserGroups.SOUND_TECHNICIAN,
  UserGroups.DATA_CONTROLLER,
]

export const EmployeesMultiSelect = ({
  value,
  onChange,
  placeholder,
  groups = DEFAULT_GROUPS,
}: EmployeesMultiSelectProps): JSX.Element => {
  const { data: users } = useUsersByGroups({ groups })

  return (
    <SearchAutocomplete
      value={value}
      onChange={onChange}
      options={users?.map(
        ({ id, first_name, last_name, email }) =>
          ({
            label: first_name
              ? `${id}: ${first_name} ${last_name}`
              : `${id}: ${email}`,
            value: id.toString(),
          } as SearchAutocompleteOption)
      )}
      sort={true}
      placeholder={placeholder}
      fieldSx={{ width: { xs: 390, md: 300 } }}
    />
  )
}
